import { CanvasService } from "appworks/graphics/canvas/canvas-service";
import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";
import { uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";
import { LayerNames } from "game-layers";

/**
 * A class that detects when a user clicks inside a designated area for autoplay functionality.
 */
export class AutoplayClickDetector {
    /**
     * Initializes the AutoplayClickDetector by adding the canvas clicked listener.
     */
    public static init(): void {
        const canvasService = Services.get(CanvasService);

        // Click detection code reacts to canvas clicked signals
        canvasService.onCanvasClicked.add((event: PointerEvent | TouchEvent) => {
            // Get the true touch coordinates for desktop or mobile
            const isTouchEvent = event.type == 'touchend';
            const x = isTouchEvent ? (event as TouchEvent).changedTouches[0].clientX : (event as PointerEvent).clientX;
            const y = isTouchEvent ? (event as TouchEvent).changedTouches[0].clientY : (event as PointerEvent).clientY;
            const mousePos = canvasService.getPixiMousePosition(x, y);

            // Obtain ref for the autoplay background
            const menusLayer = Layers.get(LayerNames.MenusContent);
            const bgSprite = menusLayer.getSprite("autoplay_nonUK_bg");

            // VERY important. There is a bug with updateTransform on a Sprite where the parent
            // containers occasionally do not all recursively have their world transforms updated correctly.
            // This ensures the world transforms will all be correct prior to the hit test.
            bgSprite?.parent?.updateTransform();
            const isInside = bgSprite?.containsPoint(mousePos) ?? false;

            // Close menu if click is outside the background bounds
            if(uiFlags.has(UIMenuFlag.AUTO) && !isInside) {
                uiFlags.closeMenus();
            }
        });
    }
}